var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.errorMsg)?_c('LoadingSpinner',{staticClass:"mt-12"}):_vm._e(),(_vm.errorMsg)?_c('v-alert',{staticClass:"ma-8",attrs:{"type":"error","outlined":""}},[_vm._v(" "+_vm._s(_vm.errorMsg)+" "),_c('div',{staticClass:"mt-6"},[_c('ContactSupportInfo')],1)]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }